module.exports = __webpack_public_path__ + "static/img/hb_45-min.4feac22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_45-min.png
// module id = Vbxw
// module chunks = 1